import {
  Button,
  Chip,
  Grid,
  Modal,
  Pagination,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import InputField from "../FormComponents/InputField";
import SelectingTable from "../FormComponents/SelectingTable";
import { getSubProductsSelectionByPaging } from "../services/SubOrderProduct";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // height: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function SubProductSelectingPopup({
  setOpenProductTable,
  openProductTable,
  handleCloseProductTable,
  setSelectedProduct,
  selectedProduct,
  isOneChoise,
}) {
  const [page, setPage] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [subProductRows, setSubProductRows] = React.useState([]);

  /// filter area /////////////////////////////////

  // filter values
  const [filter, setFilter] = useState({
    _productName: "",
    _productCode: "",
  });

  //to handle changing filters
  const handleFilterChange = (name, val) => {
    setFilter({
      ...filter,
      [name]: val,
    });
  };

  //reset filters
  const resetFilters = () => {
    setFilter({
      _productName: "",
      _productCode: "",
    });
  };

  /////////////////////////////////////////////////

  const handleChangepage = async (event, value) => {
    setPage(value - 1);
  };

  useEffect(async () => {
    await fetchData();
  }, [page, filter]);

  const fetchData = async () => {
    setOpenProductTable(true);
    //get import items data when page loading...
    let result = await getSubProductsSelectionByPaging(
      page,
      rowsPerPage,
      filter
    );

    if (!result || !Array.isArray(result.content)) {
      setSubProductRows([]);
      return;
    }

    let productSet = result.content;

    //set total rows and pages
    setTotalPages(result.totalPages);

    const newSet = [];
    if (productSet?.length != 0) {
      for (let x = 0; x < productSet?.length; x++) {
        let inputCount = productSet[x].subOrderItems
          ? productSet[x].subOrderItems.filter(
              (item) => item.itemType === "INPUT"
            ).length
          : 0;

        let outputItem = (productSet[x].subOrderItems || []).filter(
          (item) => item.itemType === "OUTPUT"
        );

        console.log("outputItem", outputItem);

        const out = outputItem[0];
        const outputDisplayName = out
          ? out.imports
            ? out.imports.itemName + " (" + out.imports.product_code + ")"
            : out.importCategory
            ? out.importCategory.category
            : "N/A"
          : "N/A";

        newSet.push(
          createData(
            productSet[x].subProductName,
            outputDisplayName,
            inputCount,
            productSet[x].subProductId
          )
        );
      }
    }

    // set rows to table
    setSubProductRows(newSet);
  };

  const columns = [
    {
      id: "_productName",
      numeric: false,
      disablePadding: true,
      label: "Product Name",
    },
    {
      id: "_outputProduct",
      numeric: false,
      disablePadding: true,
      label: "Output Product",
    },
    {
      id: "_inputItemCount",
      numeric: true,
      disablePadding: true,
      label: "Input Item Count",
    },
  ];

  function createData(
    _productName,
    _outputProduct,
    _inputItemCount,
    _productId
  ) {
    return {
      _productName,
      _outputProduct,
      _inputItemCount,
      _productId,
    };
  }

  return (
    <Grid item xs={12} sm={9} sx={12} sx={{ mt: 2 }}>
      <Modal
        keepMounted
        open={openProductTable}
        onClose={handleCloseProductTable}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Paper sx={style}>
          <Grid container>
            <Grid item xs={12} sm={12} sx={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2} sx={12}>
                  <InputField
                    name="_productName"
                    value={filter._productName}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Sub Product Name"
                  />
                </Grid>
                <Grid item xs={12} sm={3} sx={12}>
                  <InputField
                    name="_productCode"
                    value={filter._productCode}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Output Product Code"
                  />
                </Grid>
                <Grid item xs={12} sm={4} sx={12}>
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        resetFilters();
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        fetchData();
                      }}
                    >
                      Filter
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} sx={12}>
              <SelectingTable
                isOneChoise={isOneChoise}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                title="Sub Order Products"
                columns={columns}
                rows={subProductRows}
                setSelected={setSelectedProduct}
                selected={selectedProduct}
                _key="_productId"
                setOpenTable={setOpenProductTable}
                handleCloseTable={handleCloseProductTable}
              />
            </Grid>

            <Stack spacing={3}>
              <Pagination
                count={totalPages}
                variant="outlined"
                shape="rounded"
                size="small"
                onChange={handleChangepage}
              />
            </Stack>
          </Grid>
        </Paper>
      </Modal>
    </Grid>
  );
}
